import React, { Fragment, useState, useEffect } from 'react';
import { Button, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Form, InputGroup } from 'reactstrap';
import { useForm, Controller } from "react-hook-form";
import WhatsappComponent from '../../Common/WhatsappComponent';
import { decodeString, getWAComponents, handleErrorResponse, parseJSON, populateFormDetails, showToast, uploadFileIntoS3 } from '../../Common/Appcommon';
import Loading from '../../Common/Loading';
import PreviewPanel from '../WhatsappComponents/PreviewPanel';
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import requestApiService from '../../services/requestApi.service';

const MediaModal = (props) => {
    let { toggleMediaModal, template, isOpen } = props;
    const form = useForm();
    const { handleSubmit: handleActionFormSubmit, control, formState: { errors }, trigger } = form;
    const [formData, setFormData] = useState({});
    const [previewData, setPreviewData] = useState({});
    const [leadFormDetails, setLeadFormDetails] = useState([]);
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [showButtonLoading, setShowButtonLoading] = useState(false);
    let components = parseJSON(decodeString(template['Components']));
    let waComponents = getWAComponents(components);
    useEffect(() => {
        const fetchFormDetails = async () => {
            let formDetails = await populateFormDetails("table_236");
            setLeadFormDetails(formDetails);
        };

        fetchFormDetails();
    }, []);

    useEffect(() => {
        if (template['media_info']) {
            try {
                let mediaInfo = JSON.parse(template['media_info']);
                setFormData(mediaInfo);
            } catch (error) {
                console.error("Error parsing media_info:", error);
                setFormData({});
            }
        } else {
            setFormData({});
        }
    }, [template]);
    useEffect(() => {
        if (isOpen) {
            if (template?.media_info) {
                let mediaInfo = JSON.parse(template.media_info);
                if (JSON.stringify(mediaInfo) !== JSON.stringify(formData)) {
                    setFormData(mediaInfo);
                }
            } else {
                setFormData({});
            }
        }
    }, [isOpen]);
    const onFileUpload = async (e) => {
        let { formInputData } = await uploadFileIntoS3(e, formData);
        setFormData(prev => ({ ...prev, ...formInputData }));
        setIsFileUploaded(true);        
    }

    const handleInputChange = () => {

    }

    const onSaveMediaManager = async (e) => {
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": 'TEMPLATES_MEDIA_UPDATE',
            "isOtherApiReq": true,
            "FORMID": template['table_62_id'],
            "DATA" : formData,
        }
        let res = await requestApiService.processServerRequest(params, "WebV2", "post");
        if (res.issuccess) {
            showToast("Saved Successfully.")
            onClose();
        } else {
            handleErrorResponse(res.errormsg)
        }
    }
    const onClose = () => {
        setFormData({});
        toggleMediaModal();
    }
    return (
        <Fragment>
            <Modal isOpen={isOpen} className="media-manager-dialog">
                <ModalHeader className={"media-manager-header"}>
                    <div className='col-md-12 d-flex'>
                        <div className='col-md-6'>Media Manager - {template['Name']}</div>
                        <div className='col-md-6 d-flex justify-end'>
                            <Button onClick={onClose} className={'m-1 me-2 btn-icon '} color={'light'}>
                                <FontAwesomeIcon icon={faXmark} />
                            </Button>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={'8'}>
                            <div className=''>
                                <WhatsappComponent
                                    form={form}
                                    controller={Controller}
                                    errors={errors}
                                    waComponents={waComponents}
                                    handleInputChange={handleInputChange}
                                    onFileUpload={onFileUpload}
                                    previewData={previewData}
                                    leadFormDetail={[]}
                                    formData={formData}
                                />
                            </div>
                        </Col>
                        <Col md={'4'}>
                            <PreviewPanel
                                components={components}
                                previewData={previewData}
                                waComponents={waComponents}
                                formData={formData}
                                source={'media-manager'}
                            />
                        </Col>
                    </Row>

                </ModalBody>

                <ModalFooter className={`${isFileUploaded ? '' : 'hide'}`}>
                    <Loading showLoader={showButtonLoading} mainContent={
                        <Fragment>
                            <Button onClick={(e) => { onSaveMediaManager(e) }} className='d-flex flex-center align-center theme-bg-g'>
                                Save
                            </Button>
                        </Fragment>
                    } />
                </ModalFooter>
            </Modal>
        </Fragment>
    )
}
export default MediaModal;
